/**
 * @generated SignedSource<<ee9155b79b996516500610a6ad6297a4>>
 * @relayHash 6157ca61a6336b3422076fe92ddce48f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7efa98fd3ab9cf491fd7115472ff73b713b1485891b7a8da3895b6164a4efad8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AccessStatus = "ANONYMOUS_ACCESS" | "EXTERNAL_COLLABORATOR_ACCESS" | "EXTERNAL_SHARE_ACCESS" | "LICENSED_ADMIN_ACCESS" | "LICENSED_USE_ACCESS" | "NOT_PERMITTED" | "UNLICENSED_AUTHENTICATED_ACCESS" | "%future added value";
export type useIsInconsistentLicenseQuery$variables = Record<PropertyKey, never>;
export type useIsInconsistentLicenseQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly accessStatus: AccessStatus;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useIsInconsistentLicenseQuery = {
  response: useIsInconsistentLicenseQuery$data;
  variables: useIsInconsistentLicenseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accessStatus"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsInconsistentLicenseQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsInconsistentLicenseQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6157ca61a6336b3422076fe92ddce48f",
    "id": "7efa98fd3ab9cf491fd7115472ff73b713b1485891b7a8da3895b6164a4efad8",
    "metadata": {},
    "name": "useIsInconsistentLicenseQuery",
    "operationKind": "query",
    "text": "query useIsInconsistentLicenseQuery{user:confluence_atlassianUser(current:true){id,confluence{accessStatus}}}"
  }
};
})();

(node as any).hash = "9a564a9cef3c3d68d5077a747c253865";

export default node;
